export const navData = [
  { id: 1, title: "Pricing", link: "#pricing" },
  { id: 2, title: "Documentation", link: "#documentation" },
  { id: 3, title: "Security", link: "#security" },
  { id: 4, title: "Contact", link: "#contact" },
];
